export default "__VITE_ASSET__BM0$uBfb__"